/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react'

import { useHistory } from 'react-router-dom'

import { toast } from 'react-toastify'
import axios from 'axios'

import ProfileDoctor from '../../../../../presentation/pages/doctors/profile'

import { useMe } from '../../../../../presentation/contexts/me'

import {
  makeDoctor,
  makeDoctorsEdit,
} from '../../../../usecases/doctors/remote-doctors-factory'
import { makeSpecialties } from '../../../../usecases/specialties/remote-specialties-factory'
import { makeCities } from '../../../../usecases/cities/remote-cities-factory'
import { makeUsers } from '../../../../usecases/users/remote-users-factory'

import ISubscription from '../../../../../presentation/interfaces/subscription'
import {
  PaymentType,
  RoutesEnum,
  Authority,
} from '../../../../../presentation/enums'
import {
  getRoute,
  HelperAmplify,
  LinkBuilder,
} from '../../../../../presentation/helpers'

const MakeProfileDoctor = () => {
  document.title = 'BuscarMédicos - Perfil'

  const [editingFields, setEditingFields] = useState({
    name: false,
    about: false,
    address: false,
    comments: false,
    specialty: false,
    cities: false,
    availability: false,
    medicalUnit: false,
    cv: false,
    plan: false,
  })

  const [user, setUser] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    about: '',
    address: {
      zipcode: '',
      street: '',
      number: '',
      neighborhood: '',
      city: '',
      state: '',
      complement: '',
    },
    specialties: [
      {
        id: 0,
        name: '',
        enabled: false,
      },
    ],
    cities: [
      {
        id: 0,
        name: '',
        ibge: 0,
        state: {
          id: 0,
          name: '',
          siglaIsoIntegration: '',
        },
      },
    ],
    availability: [
      {
        key: 0,
        afternoon: false,
        dayWeek: '',
        id: 0,
        morning: false,
        night: false,
      },
    ],
    observation: '',
    status: true,
    workingPlaces: [''],
    cv: '',
    plan: {
      id: 0,
      period: '',
      value: '',
      promotionalPrice: '',
    },
    document: [
      {
        id: 0,
        url: '',
      },
    ],
    medicoVo: {
      crm: null,
      dataAtualizacao: null,
      dataNascimento: null,
      especialidade: [],
      nome: null,
      situacao: null,
      tipoInscricao: null,
      uf: null,
    },
  })

  const [available, setAvailable] = useState(user.status)
  const [aboutValue, setAboutValue] = useState(user.about)
  const [observationValue, setObservationValue] = useState(user.observation)
  const [, setAddressValue] = useState(user.address)
  const [availability, setAvailability] = useState(user.availability)

  const [editableList, setEditableList] = useState<
    { id: number; value: string }[]
  >([])
  const pdfInputRef = useRef<HTMLInputElement>(null)
  const [selectedFile, setSelectedFile] = useState<string | null>(null)
  const history = useHistory()
  const { me, updateMe } = useMe()
  const [specialtiesData, setSpecialtiesData] = useState<any>([])
  const [cities, setCities] = useState<Array<any>>([])
  const [city, setCity] = useState([])
  const [selectedState, setSelectedState] = useState<any>()
  const [local, setLocal] = useState<string>('')
  const [localBlock, setLocalBlock] = useState<string[]>([])
  const [subscription, setSubscription] = useState<ISubscription>({
    active: false,
    hasPendingPayment: false,
    nextPaymentAt: new Date(),
    startAt: new Date(),
    paymentMethod: PaymentType.CREDIT,
    status: '',
    urlBoleto: '',
    urlBoletoPdf: '',
  })
  const [billingModalOpen, setBillingModalOpen] = useState(false)

  useEffect(() => {
    const handleSearchCities = async () => {
      try {
        if (selectedState) {
          let stateId: number

          switch (selectedState) {
            case 'AC':
              stateId = 1
              break
            case 'AL':
              stateId = 2
              break
            case 'AM':
              stateId = 3
              break
            case 'AP':
              stateId = 4
              break
            case 'BA':
              stateId = 5
              break
            case 'CE':
              stateId = 6
              break
            case 'DF':
              stateId = 7
              break
            case 'ES':
              stateId = 8
              break
            case 'GO':
              stateId = 9
              break
            case 'MA':
              stateId = 10
              break
            case 'MG':
              stateId = 11
              break
            case 'MS':
              stateId = 12
              break
            case 'MT':
              stateId = 13
              break
            case 'PA':
              stateId = 14
              break
            case 'PB':
              stateId = 15
              break
            case 'PE':
              stateId = 16
              break
            case 'PI':
              stateId = 17
              break
            case 'PR':
              stateId = 18
              break
            case 'RJ':
              stateId = 19
              break
            case 'RN':
              stateId = 20
              break
            case 'RO':
              stateId = 21
              break
            case 'RR':
              stateId = 22
              break
            case 'RS':
              stateId = 23
              break
            case 'SC':
              stateId = 24
              break
            case 'SE':
              stateId = 25
              break
            case 'SP':
              stateId = 26
              break
            case 'TO':
              stateId = 27
              break
            default:
              console.error('Abreviação de estado inválida:', selectedState)
              return
          }

          const response = await makeCities().loadById(stateId)
          const transformedResponse = response.map((cityOBJ: any) => ({
            ...cityOBJ,
            id: cityOBJ.id.toString(),
          }))
          setCities(transformedResponse)
        }
      } catch (error) {
        toast.error('Erro ao carregar dados pelo ID.')
      }
    }

    handleSearchCities()
  }, [selectedState])

  useEffect(() => {
    const fetchSpecialties = async () => {
      try {
        const response = await makeSpecialties().load()
        const specialities = response.content
          .filter((item: any) => item.active)
          .map((item: any) => ({
            key: String(item.id),
            id: String(item.id),
            nome: item.name,
            situação: item.enabled,
          }))
        setSpecialtiesData(specialities)
      } catch (error) {
        toast.error('Erro ao carregar especialidades.')
      }
    }

    fetchSpecialties()
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      if (!me) {
        return
      }

      try {
        const response = await makeUsers().loadDoctorById(me.id)

        setUser(response)
        setAboutValue(response.about)
        setSelectedState(response.address.state)
        setObservationValue(response.observation)
        setAvailable(response.status)
      } catch (error) {
        toast.error('Erro ao carregar especialidades.')
      }
    }

    fetchData()
  }, [me])

  useEffect(() => {
    handleAddLocals()
  }, [localBlock])

  useEffect(() => {
    setAvailability(user.availability)
  }, [user.availability])

  useEffect(() => {
    const fetchSubscription = async () => {
      if (me) {
        const response = await makeUsers().loadSubscription(me.id)
        setSubscription(response[response.length - 1])
      }
    }

    fetchSubscription()
  }, [me?.id])

  useEffect(() => {
    if (subscription.hasPendingPayment) {
      setBillingModalOpen(true)
    }
  }, [subscription.hasPendingPayment])

  function handleUpdateSetCity(data: any) {
    const objetoArray = data.map((jsonString: any) => JSON.parse(jsonString))
    setCity(objetoArray)
  }

  const handleEditAddress = () => {
    history.push(RoutesEnum.EDIT_ADDRESS_DOCTOR)
  }

  const handleEditAvailability = () => {
    history.push(RoutesEnum.EDIT_AVAILABILITY_DOCTOR)
  }

  const handleEditHeader = () =>
    history.push(RoutesEnum.EDIT_HEADER_DATA_DOCTOR)

  const redirectToPlans = () => {
    history.push(getRoute(RoutesEnum.PLANS, { type: Authority.DOCTOR }))
  }

  const toggleBillingModalVisibility = () => {
    setBillingModalOpen(!billingModalOpen)
  }

  const handleSwitch = async () => {
    try {
      const status = !available
      if (me) {
        await makeDoctor().editStatus(me.id, status)
      }

      setAvailable(status)
    } catch (error: any) {
      toast.error(`Erro ao alterar o status: ${error.message}`)
    }
  }

  const handleEditClick = (field: any) => {
    setEditingFields((prevEditingFields) => ({
      ...prevEditingFields,
      [field]: true,
    }))
  }

  const handleAboutEdit = async () => {
    try {
      if (me) {
        const updatedUser = { about: aboutValue }
        await makeDoctorsEdit().update(me.id, updatedUser)
        window.location.reload()
      } else {
        throw new Error('Usuário não encontrado.')
      }
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  const handleCommentsEdit = async () => {
    try {
      if (me) {
        const updatedUser = { observation: observationValue }
        await makeDoctorsEdit().update(me.id, updatedUser)
        window.location.reload()
      } else {
        throw new Error('Usuário não encontrado.')
      }
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  const handleRemoveSpecialtie = async (itemId: number) => {
    try {
      if (me) {
        const updatedSpecialties = user.specialties.filter(
          (item) => item.id !== itemId,
        )
        const updatedUser = { specialties: updatedSpecialties }

        await makeDoctorsEdit().update(me.id, updatedUser)
        window.location.reload()
      } else {
        throw new Error('Usuário não encontrado.')
      }
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  const handleRemoveCity = async (itemId: number) => {
    try {
      if (me) {
        const updatedCities = user.cities.filter((item) => item.id !== itemId)
        const updatedUser = { cities: updatedCities }

        await makeDoctorsEdit().update(me.id, updatedUser)
        window.location.reload()
      } else {
        throw new Error('Usuário não encontrado.')
      }
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  const handleRemoveLocal = async (localName: string) => {
    try {
      if (me) {
        const updatedLocais = user.workingPlaces.filter(
          (local) => local !== localName,
        )
        const updatedUser = { workplace: updatedLocais }

        await makeDoctorsEdit().update(me.id, updatedUser)
        window.location.reload()
      } else {
        throw new Error('Usuário não encontrado.')
      }
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  const handleCancellClick = (field: string) => {
    setEditingFields((prevEditingFields) => ({
      ...prevEditingFields,
      [field]: false,
    }))
  }

  const handlePdfUpload = (file: File | null) => {
    if (file) {
      setSelectedFile(file ? file.name : null)
    }
  }

  const handleLogout = async () => {
    updateMe(null as any)

    await HelperAmplify.signOut()

    history.push('/')
  }

  const handleDownloadPdf = async () => {
    try {
      const pdfDocuments = user.document.filter((doc) =>
        doc.url.endsWith('.pdf'),
      )

      if (pdfDocuments.length === 0) {
        console.error('Nenhum documento PDF encontrado para download.')
        return
      }

      const sortedPdfDocuments = pdfDocuments.sort((a, b) => b.id - a.id)

      const latestPdfDocument = sortedPdfDocuments[0]

      const pdfUrl = LinkBuilder.buildAssetsUrl(latestPdfDocument.url)

      window.open(pdfUrl, '_blank')
    } catch (error) {
      console.error('Erro ao abrir a URL do arquivo:', error)
    }
  }

  const dataForm = [
    {
      items: [
        {
          component: 'SelectChecklist',
          name: 'specialties',
          required: true,
          placeholder: 'Especialidades',
          options: specialtiesData.map((option: any) => ({
            label: option.nome,
            value: JSON.stringify({ id: option.id, nome: option.nome }),
          })),
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Prosseguir',
          submittingText: 'Carregando...',
          color: true,
        },
      ],
    },
  ]

  const handleUpdateSpcialtie = async (values: any): Promise<void> => {
    try {
      if (me) {
        const newSpecialties = values.specialties.map(
          (specialtyString: any) => {
            const parsedSpecialty = JSON.parse(specialtyString)
            return { id: parseInt(parsedSpecialty.id, 10) }
          },
        )

        const requestData = {
          specialties: [...user.specialties, ...newSpecialties],
        }

        await makeDoctorsEdit().update(me.id, requestData)
        window.location.reload()
      } else {
        throw new Error('Usuário não encontrado.')
      }
    } catch (error) {
      toast.error(
        'Erro ao enviar formulário, revise os campos e tente novamente.',
      )
    }
  }

  const dataForm2 = [
    {
      items: [
        {
          component: 'SelectChecklist',
          name: 'cities',
          required: true,
          placeholder: 'Cidades apto a trabalho',
          options: cities.map((option) => ({
            label: option.name,
            value: JSON.stringify({ id: option.id, nome: option.name }),
          })),
          onChange: handleUpdateSetCity,
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Prosseguir',
          submittingText: 'Carregando...',
          color: true,
        },
      ],
    },
  ]

  const handleUpdateCities = async (values: any): Promise<void> => {
    try {
      if (me) {
        const cityIds = values.cities.map((cityString: any) => {
          const parsedCity = JSON.parse(cityString)
          return parseInt(parsedCity.id, 10)
        })

        const requestData = {
          cities: [
            ...user.cities.map((city) => ({ id: city.id })),
            ...cityIds.map((id: number) => ({ id })),
          ],
        }

        await makeDoctorsEdit().update(me.id, requestData)
        window.location.reload()
      } else {
        throw new Error('Usuário não encontrado.')
      }
    } catch (error) {
      toast.error(
        'Erro ao enviar formulário, revise os campos e tente novamente.',
      )
    }
  }

  const handleAddLocals = () => {
    if (local) {
      setLocalBlock((prevLocals) => [...prevLocals, local])
      setLocal('')
    }
  }

  function handleAddLocal(data: any) {
    setLocal(data)
  }

  const dataForm3 = [
    {
      items: [
        {
          name: 'local',
          component: 'Input',
          placeholder: 'Digite aqui',
          type: 'text',
          title: 'Add locais de trabalho',
          label: 'Add locais de trabalho',
          required: true,
          onChange: handleAddLocal,
        },
        {
          name: 'textline',
          component: 'Textline',
          title: localBlock.map((option: any) => ({
            value: option,
          })),
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Prosseguir',
          submittingText: 'Carregando...',
          color: true,
        },
      ],
    },
  ]

  const handleUpdateLocals = async (): Promise<void> => {
    try {
      if (me) {
        const requestData = {
          workplace: user.workingPlaces.concat(...localBlock),
        }

        await makeDoctorsEdit().update(me.id, requestData)
        window.location.reload()
      } else {
        throw new Error('Usuário não encontrado.')
      }
    } catch (error) {
      toast.error(
        'Erro ao enviar formulário, revise os campos e tente novamente.',
      )
    }
  }

  const uploadCV = async (file: File) => {
    try {
      const userEmail = me?.email

      if (!userEmail) {
        throw new Error('E-mail não encontrado no localStorage')
      }

      const formData = new FormData()
      formData.append('file', new File([file], file.name))

      formData.append('email', userEmail)

      formData.append('type', 'application/pdf') // se pdf: application/pdf

      const apiUrl = process.env.REACT_APP_API_URL

      const response = await axios.post(
        ` ${apiUrl}/public/register/doctor/upload-file`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      window.location.reload()
      return response.data
    } catch (error) {
      toast.error('Erro ao enviar CVm, formato não suportado.')
      throw error
    }
  }

  const imageUrl = user.document.find((doc) =>
    doc.url.startsWith('images/'),
  )?.url

  const name = `${user.firstName} ${user.lastName}`

  const formattedValue = user.plan.value.toString().replace(/\./g, ',')
  const formattedPromotionalValue = user.plan.promotionalPrice
    ? user.plan.promotionalPrice.toString().replace(/\./g, ',')
    : null

  const planInfo = formattedPromotionalValue
    ? `${user.plan.period} - de: R$${formattedValue} - Por: R$${formattedPromotionalValue}`
    : `${user.plan.period} - R$${formattedValue}`

  return (
    <ProfileDoctor
      medico={user.medicoVo}
      handleEditHeader={handleEditHeader}
      handleEditAvailability={handleEditAvailability}
      handleRemoveLocal={handleRemoveLocal}
      handleCommentsEdit={handleCommentsEdit}
      handleAddLocals={handleAddLocals}
      handleUpdateLocals={handleUpdateLocals}
      dataform3={dataForm3}
      handleRemoveCity={handleRemoveCity}
      dataform2={dataForm2}
      handleUpdateCities={handleUpdateCities}
      dataForm={dataForm}
      onSubmit={handleUpdateSpcialtie}
      handleEditAddress={handleEditAddress}
      aboutValue={aboutValue}
      handleAboutEdit={handleAboutEdit}
      handleDownloadPdf={handleDownloadPdf}
      redirectToPlans={redirectToPlans}
      selectedFile={selectedFile}
      handlePdfUpload={handlePdfUpload}
      pdfInputRef={pdfInputRef}
      handleEditClick={handleEditClick}
      editingFields={editingFields}
      setAvailable={handleSwitch}
      available={available}
      setAboutValue={setAboutValue}
      setAddressValue={setAddressValue}
      setObservationValue={setObservationValue}
      observationValue={observationValue}
      editableList={editableList}
      handleRemoveSpecialtie={handleRemoveSpecialtie}
      handleCancellClick={handleCancellClick}
      name={name}
      email={user.email}
      phone={user.phone}
      about={user.about}
      address={user.address}
      specialties={user.specialties}
      workingPlaces={user.workingPlaces}
      cities={user.cities}
      availability={availability}
      observation={user.observation}
      handleLogout={handleLogout}
      imageUrl={imageUrl}
      uploadCV={uploadCV}
      plan={planInfo}
      subscription={subscription}
      billingModalOpen={billingModalOpen}
      toggleBillingModalVisibility={toggleBillingModalVisibility}
    />
  )
}

export default MakeProfileDoctor
